import { SxProps, Theme } from "@mui/material";
import { Spinner } from "@yardzen/ui/components/spinner";

interface LoadingSpinnerProps {
  sx?: SxProps<Theme>;
  className?: string;
}

export function LoadingSpinner({ sx, className }: LoadingSpinnerProps) {
  // Convert sx prop to className for backwards compatibility
  let additionalClasses = className || "";

  if (sx) {
    const sxObj = Array.isArray(sx) ? Object.assign({}, ...sx) : sx;
    if (typeof sxObj === "object") {
      if (sxObj.width === "100%") additionalClasses += " w-full";
      if (sxObj.height === "100%") additionalClasses += " h-full";
      if (sxObj.width === "3rem") additionalClasses += " w-12";
      if (sxObj.height === "3rem") additionalClasses += " h-12";
    }
  }

  return (
    <div
      className={`flex h-screen w-screen items-center justify-center ${additionalClasses}`.trim()}
    >
      <Spinner />
    </div>
  );
}
